import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { VolumeFullSolid } from '@bnnvara/icons/src/components/UserInterfaceIcons/VolumeFullSolid';
import { VolumeMutedSolid } from '@bnnvara/icons/src/components/UserInterfaceIcons/VolumeMutedSolid';
import { ClickWrapper } from '@/components/HeaderHero';
import { HeroContent } from '@/components/HeaderHero/HeroContent';
import { trackAllAnalytics } from '@bnnvara/analytics/src/track';
import useAnalyticProperties from '@/hooks/useAnalyticProperties';
import * as S from './styled';

const VideoHero = ({ data }) => {
  const { videoUrl, url, title, readMoreText } = data;
  const analyticsProperties = useAnalyticProperties();

  const [isMuted, setIsMuted] = useState(true);

  const toggleMute = () => {
    setIsMuted(!isMuted);
    trackAllAnalytics(`klik_hero_sound_muted_${isMuted}`, {
      ...analyticsProperties,
      category: 'Header',
    });
  };

  return (
    <>
      <S.ControlContainer>
        {isMuted ? (
          <S.IconButton
            onClick={() => toggleMute()}
            aria-label="Geluid uit"
            aria-pressed={isMuted}
            aria-haspopup="false"
            role="button"
          >
            <VolumeMutedSolid />
          </S.IconButton>
        ) : (
          <S.IconButton
            onClick={() => toggleMute()}
            aria-label="Geluid aan"
            aria-pressed={!isMuted}
            aria-haspopup="false"
            role="button"
          >
            <VolumeFullSolid />
          </S.IconButton>
        )}
      </S.ControlContainer>
      <ClickWrapper url={url} type="Video" title={title}>
        {readMoreText && (
          <HeroContent
            title={title}
            url={url}
            readMore={readMoreText}
            type="video_teaser"
          />
        )}
        <S.VideoContainer>
          <S.VideoHero autoPlay playsInline muted={isMuted} loop>
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </S.VideoHero>
        </S.VideoContainer>
      </ClickWrapper>
    </>
  );
};

VideoHero.propTypes = {
  data: PropTypes.shape({
    url: PropTypes.string.isRequired,
    videoUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    readMoreText: PropTypes.string,
  }).isRequired,
};

export default VideoHero;
